import React, { useCallback, useEffect, useRef, useState } from 'react';

import rechercherImg from '@public/images/rechercher.png';
import {
  EXCLUDED_JOB_TITLE_CODE,
  buildRecruitSocietyUrl,
  fetchSearchConditions,
  hasSearchFilters,
  parseSearchQuery,
  toOptionMap,
} from '../../shared/rechercherApi';

function Rechercher({
  mode = 'redirect',
  filters: controlledFilters,
  onFiltersChange,
  onSearch,
}) {
  const [internalFilters, setInternalFilters] = useState(parseSearchQuery);
  const [regions, setRegions] = useState({});
  const [jobTitles, setJobTitles] = useState({});
  const [searching, setSearching] = useState(false);

  const filters = controlledFilters ?? internalFilters;
  const filtersRef = useRef(filters);
  filtersRef.current = filters;

  const updateFilters = useCallback(
    (nextFilters) => {
      const resolved =
        typeof nextFilters === 'function' ? nextFilters(filtersRef.current) : nextFilters;

      if (onFiltersChange) {
        onFiltersChange(resolved);
      } else {
        setInternalFilters(resolved);
      }
    },
    [onFiltersChange]
  );

  const loadConditions = useCallback(async () => {
    try {
      const result = await fetchSearchConditions();
      if (result.flag === 1) {
        const { dqs = [], jobTitles: titles = [] } = result.data || {};
        setRegions(toOptionMap(dqs));
        setJobTitles(toOptionMap(titles, EXCLUDED_JOB_TITLE_CODE));
      }
    } catch (err) {
      // 筛选项加载失败不阻塞页面
    }
  }, []);

  useEffect(() => {
    loadConditions();
  }, [loadConditions]);

  const handleDqChange = (value) => {
    updateFilters((prev) => ({
      ...prev,
      dq: value,
      jobTitleCode: '',
    }));
    loadConditions();
  };

  const handleSearch = async () => {
    const currentFilters = filtersRef.current;

    if (mode === 'inline') {
      setSearching(true);
      try {
        await onSearch?.(currentFilters);
      } finally {
        setSearching(false);
      }
      return;
    }

    if (!hasSearchFilters(currentFilters)) {
      return;
    }

    window.location.href = buildRecruitSocietyUrl(currentFilters);
  };

  const handleKeywordKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleSearch();
    }
  };

  return (
    <div className="rechercher">
      <div className="title">
        <img src={rechercherImg} alt="职位搜索" />
      </div>
      <div className="list">
        <ul>
          <li>
            <select value={filters.dq} onChange={(event) => handleDqChange(event.target.value)}>
              <option value="">请选择工作地点</option>
              {Object.entries(regions).map(([code, name]) => (
                <option key={code} value={code}>
                  {name}
                </option>
              ))}
            </select>
          </li>
          <li>
            <select
              value={filters.jobTitleCode}
              onChange={(event) =>
                updateFilters((prev) => ({ ...prev, jobTitleCode: event.target.value }))
              }
            >
              <option value="">请选择职位类别</option>
              {Object.entries(jobTitles).map(([code, name]) => (
                <option key={code} value={code}>
                  {name}
                </option>
              ))}
            </select>
          </li>
          <li>
            <input
              type="text"
              placeholder="请输入职位关键字"
              value={filters.keywords}
              onChange={(event) =>
                updateFilters((prev) => ({ ...prev, keywords: event.target.value }))
              }
              onKeyDown={handleKeywordKeyDown}
            />
          </li>
        </ul>
      </div>
      <div className="submit">
        <button type="button" onClick={handleSearch} disabled={searching}>
          {searching ? '搜索中...' : '搜索'}
        </button>
      </div>
    </div>
  );
}

export default Rechercher;
